import React, { useState } from "react";
import { HexColorPicker } from "react-colorful";
import { Box, Popover } from "@material-ui/core";

const PRESET_COLORS = [
	"#ffffff", "#f8fafc", "#f1f5f9", "#e2e8f0", "#cbd5e1", "#94a3b8", "#64748b",
	"#475569", "#334155", "#1e293b", "#0f172a",
	"#fef2f2", "#fecaca", "#fca5a5", "#ef4444", "#dc2626",
	"#fef3c7", "#fde68a", "#fbbf24", "#f59e0b", "#d97706",
	"#ecfccb", "#d9f99d", "#a3e635", "#84cc16", "#65a30d",
	"#d1fae5", "#a7f3d0", "#34d399", "#10b981", "#059669",
	"#ccfbf1", "#99f6e4", "#2dd4bf", "#14b8a6", "#0d9488",
	"#cffafe", "#a5f3fc", "#22d3ee", "#06b6d4", "#0891b2",
	"#dbeafe", "#bfdbfe", "#60a5fa", "#3b82f6", "#2563eb",
	"#e0e7ff", "#c7d2fe", "#818cf8", "#6366f1", "#4f46e5",
	"#ede9fe", "#ddd6fe", "#a78bfa", "#8b5cf6", "#7c3aed",
	"#fce7f3", "#fbcfe8", "#f472b6", "#ec4899", "#db2777",
];

const isWhite = (h) => {
	const s = (h || "").toLowerCase().replace(/^#/, "");
	return s === "fff" || s === "ffffff";
};

export default function HexColorPickerPopover({ value, onChange, label }) {
	const [anchorEl, setAnchorEl] = useState(null);
	const hex = value && /^#([0-9A-Fa-f]{3}){1,2}$/.test(value) ? value : "#ffffff";

	const handleOpen = (e) => setAnchorEl(e.currentTarget);
	const handleClose = () => setAnchorEl(null);

	return (
		<Box>
			{label && (
				<Box fontSize={12} fontWeight={600} color="#64748b" mb={0.75}>
					{label}
				</Box>
			)}
			<Box
				onClick={handleOpen}
				title="Abrir selector de color"
				style={{
					width: 44,
					height: 36,
					borderRadius: 10,
					border: "2px solid #e2e8f0",
					backgroundColor: hex,
					cursor: "pointer",
					boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
					backgroundImage: isWhite(hex)
						? "linear-gradient(45deg, #e2e8f0 25%, transparent 25%), linear-gradient(-45deg, #e2e8f0 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #e2e8f0 75%), linear-gradient(-45deg, transparent 75%, #e2e8f0 75%)"
						: undefined,
					backgroundSize: isWhite(hex) ? "8px 8px" : undefined,
					backgroundPosition: isWhite(hex) ? "0 0, 0 4px, 4px -4px, -4px 0" : undefined,
				}}
			/>
			<Popover
				open={Boolean(anchorEl)}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
				transformOrigin={{ vertical: "top", horizontal: "left" }}
				PaperProps={{ style: { borderRadius: 12, overflow: "hidden", boxShadow: "0 10px 40px rgba(0,0,0,0.12)" } }}
			>
				<Box p={2}>
					<Box
						style={{
							height: 160,
							borderRadius: 10,
							overflow: "hidden",
							marginBottom: 12,
						}}
					>
						<HexColorPicker color={hex} onChange={onChange} style={{ width: "100%", height: "100%" }} />
					</Box>
					<Box fontSize={11} color="#64748b" mb={0.75}>
						Colores rápidos
					</Box>
					<Box display="flex" flexWrap="wrap" style={{ gap: 6 }}>
						{PRESET_COLORS.map((c) => (
							<Box
								key={c}
								onClick={() => {
									onChange(c);
								}}
								style={{
									width: 24,
									height: 24,
									borderRadius: 6,
									backgroundColor: c,
									cursor: "pointer",
									border: hex.toLowerCase() === c.toLowerCase() ? "2px solid #7c3aed" : "2px solid transparent",
									boxSizing: "border-box",
								}}
							/>
						))}
					</Box>
				</Box>
			</Popover>
		</Box>
	);
}
